import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.loading');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-loading',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.loading/view.scss */
/* src/app/component.loading/view.scss: no such file or directory */`],
})
export class ComponentLoadingComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default ComponentLoadingComponent;